module.exports = __webpack_public_path__ + "static/media/title_my_collection.c31983a0.png";